import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageModal = ({ onSelect }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  const choose = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('i18n_language', lang);
    onSelect();
  };

  return (
    <div
      data-testid="language-modal-overlay"
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/85 px-4"
    >
      <div
        data-testid="language-modal"
        className="bg-[#111] border border-white/10 rounded-2xl p-8 sm:p-10 w-full max-w-sm text-center shadow-2xl"
      >
        {/* Logo */}
        <img src="/logo_icon.png" alt="Yellow Cab Corsica" className="h-16 w-16 object-contain mx-auto mb-6" />

        {/* Brand */}
        <p className="font-bold text-xl mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>
          <span className="text-[#EAB308]">Yellow</span>
          <span className="text-white"> Cab</span>
          <span className="text-[#A3A3A3] font-light"> Corsica</span>
        </p>
        <p className="text-[#555] text-xs tracking-widest uppercase mb-8">Porticcio · Corse-du-Sud</p>

        {/* Prompt */}
        <p className="text-[#A3A3A3] text-sm mb-6">Choisissez votre langue · Choose your language · Wählen Sie Ihre Sprache</p>

        {/* Buttons */}
        <div className="flex flex-col gap-3">
          <button
            onClick={() => choose('fr')}
            data-testid="lang-select-fr"
            className="flex items-center justify-center gap-3 w-full bg-[#EAB308] hover:bg-[#CA8A04] text-black font-bold py-4 rounded-xl text-base transition-colors duration-200"
          >
            <span className="text-xl">🇫🇷</span>
            Français
          </button>
          <button
            onClick={() => choose('en')}
            data-testid="lang-select-en"
            className="flex items-center justify-center gap-3 w-full bg-white/8 hover:bg-white/15 border border-white/15 text-white font-bold py-4 rounded-xl text-base transition-colors duration-200"
          >
            <span className="text-xl">🇬🇧</span>
            English
          </button>
          <button
            onClick={() => choose('de')}
            data-testid="lang-select-de"
            className="flex items-center justify-center gap-3 w-full bg-white/8 hover:bg-white/15 border border-white/15 text-white font-bold py-4 rounded-xl text-base transition-colors duration-200"
          >
            <span className="text-xl">🇩🇪</span>
            Deutsch
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageModal;
